<i class="pi pi-times z-clear-icon" (click)="onClick($event)"></i>
